﻿<template>
	<a v-if="href"
	   class="ccs-logo-learn-more"
	   :href="href"
	   :target="options.target"
	   @click="$emit('click')">
		{{ options.learnMoreText }}
	</a>
</template>

<script>
	export default {
		props: {
			href: String
		},

		inject: ["options"],
	}
</script>